<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .container {
    display: flex;
    flex: 1;
    width: 100%;
    height: 100%;
    padding: utils.in_rem(16px);
    flex-direction: column;
    align-items: flex-start;
    gap: utils.in_rem(16px);
    flex-shrink: 0;
    overflow: auto;

    border-radius: 16px;
    background: colors.get(interfaceSwGrey_5);

    &.error {
      margin-top: utils.in_rem(-20px);
    }

    .header {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      align-self: stretch;
      gap: utils.in_rem(30px);

      .text-group {
        display: flex;
        flex-direction: column;
        gap: utils.in_rem(4px);
        > h3 {
          @include colors.color(textBlack);
        }
        > span {
          @include mixins.body2();
          @include colors.color(textGrey);
        }
      }
    }

    .line {
      width: 100%;
      height: 1px;
      background: colors.get(interfaceTransparentBlack_6);
    }
  }
</style>

<script>
  // Components
  import EmailSuggestions from "./EmailSuggestions.svelte";
  import EnrichEmailsButton from "./EnrichEmailsButton.svelte";
  // Stores
  import { todoPanelStore } from "../stores";

  // messageText is used to display updates from the enriching process
  let messageText = "";
</script>

<!-- The error class presents contained being squished by the error message -->
<div class="container {$todoPanelStore.invalidEmail ? 'error' : ''}">
  <div class="header">
    <div class="text-group">
      <h3>Alternative Emails</h3>
      <span>Add email address suggestions by clicking the ‘+’ button.</span>
    </div>
    <EnrichEmailsButton bind:enrichmentText={messageText} />
  </div>
  <div class="line"></div>
  <EmailSuggestions {messageText} />
</div>
